module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "card-container"
  }, [_h('div', {
    staticClass: "card three-times"
  }, [_h('div', {
    staticClass: "card-header"
  }, [_h('h4', {
    staticClass: "card-title"
  }, ["整体院風景"])]), " ", _h('div', {
    staticClass: "card-body center-column"
  }, [_h('h5', ["外観"]), " ", _h('div', [_h('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/images/appearance.jpg"
    }
  })]), " ", _h('h5', ["待合室"]), " ", _h('div', {
    staticClass: "mgn-btm-1rem"
  }, [_h('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/images/entrance.jpg"
    }
  })]), " ", _h('div', [_h('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/images/waiting.jpg"
    }
  })]), " ", _h('h5', ["施術室"]), " ", _h('div', {
    staticClass: "mgn-btm-1rem"
  }, [_h('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/images/room-1.jpg"
    }
  })]), " ", _h('div', [_h('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/images/room-2.jpg"
    }
  })]), " ", _h('h5', ["おまけ"]), " ", _h('div', {
    staticClass: "mgn-btm-1rem"
  }, [_h('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/images/picture.jpg"
    }
  })]), " ", _h('div', [_h('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/images/doll.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ea483cf8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/pages/Interior.vue
// module id = 436
// module chunks = 0